import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import eventBus from '@/util/eventBus';
import RulePop from '../Pop/RulePop/RulePop.vue';
export default {
  components: {
    Avatar: Avatar,
    SvgIcons: SvgIcons,
    RulePop: RulePop
  },
  data: function data() {
    return {
      showRule: false,
      activeIndex: 0,
      player: null,
      isPlayerPassiveStop: false // 是否被动暂停

    };
  },
  computed: {
    // 当前正在直播的场次
    liveSession: function liveSession() {
      var ts = new Date().valueOf();
      var list = this.setting.演出场次.filter(function (v) {
        return v.开始时间 < ts && v.结束时间 > ts;
      });
      return list.length > 0 ? list[0] : null;
    },
    // 视频播放的场次
    concertInfo: function concertInfo() {
      return this.setting.演出场次[this.activeIndex];
    }
  },
  methods: {
    playVideo: function playVideo() {
      var _this = this;

      var _this$concertInfo = this.concertInfo,
          vid = _this$concertInfo.vid,
          poster = _this$concertInfo.轮播图;
      if (!vid) return;

      if (this.player) {
        this.player.setPoster(poster);
        this.player.play({
          vid: vid
        });
        return;
      } // 播放器尺寸


      var config = {
        containerId: 'video_wrap',
        vid: vid,
        width: '100%',
        height: '100%',
        playerType: 'h5',
        autoplay: true,
        endPoster: true,
        poster: poster
      };
      this.player = new window.Txplayer(config);
      this.player.on('ready', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.player.play) {
                  _context.next = 3;
                  break;
                }

                _this.player = null;
                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return _this.checkWxReady();

              case 5:
                _this.player.play();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))); // 监听播放开始进行数据点击上报

      this.player.on('playStateChange', function (state) {
        if (state === 1) {
          var 名称 = _this.concertInfo.名称;

          _this.$report.expose(_this.reportData.头图.视频播放(名称));
        } else if (state === 0) {
          _this.changeIndex(_this.activeIndex + 1);
        }
      });
    },
    // 判断微信的环境中是否OK
    checkWxReady: function checkWxReady() {
      return new Promise(function (resolve) {
        if (env.isWechat) {
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
              resolve();
            }, false);
          } else {
            document.addEventListener('WeixinJSBridgeReady', function () {
              window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
                resolve();
              });
            }, false);
          }
        } else {
          resolve();
        }
      });
    },
    listenVideo: function listenVideo() {
      var _this2 = this;

      // 监听视频暂停事件
      this.eventBus.$on('stopVideo', function () {
        var state = _this2.player.getPlayerState();

        if (state !== 1) {
          return;
        }

        _this2.isPlayerPassiveStop = true;

        _this2.player.pause();
      }); // 监听继续视频播放

      this.eventBus.$on('playVideo', function () {
        // 非被动终止播放，不用继续播放
        if (!_this2.isPlayerPassiveStop) {
          return;
        }

        _this2.isPlayerPassiveStop = false;

        _this2.player.play();
      });
    },
    // 切换索引值
    changeIndex: function changeIndex() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (num >= this.setting.演出场次.length) {
        this.activeIndex = 0;
      } else if (num < 0) {
        this.activeIndex = this.setting.演出场次.length - 1;
      } else {
        this.activeIndex = num;
      } // 视频曝光


      var 名称 = this.concertInfo.名称;
      this.$report.expose(this.reportData.头图.视频曝光(名称));
      this.playVideo();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    // 初始化播放
    this.changeIndex(); // 监听视频播放与停止

    this.listenVideo(); // 设置监听返回顶部事件

    eventBus.$on('backTop', function () {
      var top = _this3.$refs.live.offsetTop;
      window.scroll({
        left: 0,
        top: top
      });
    });
  }
};